// extracted by mini-css-extract-plugin
export var body = "_l9-0";
export var sectionHeader = "_l9-4";
export var shortcutColumns = "_l9-2";
export var shortcutList = "_l9-1";
export var shortcutSection = "_l9-3";